const ENVIRONMENT = import.meta.env;
ENVIRONMENT.VITE_CONTEXT_TOKEN_LIMIT = Number(ENVIRONMENT.VITE_CONTEXT_TOKEN_LIMIT);
ENVIRONMENT.VITE_LARGE_USER_SOURCE_TOKEN_THRESHOLD = Number(ENVIRONMENT.VITE_LARGE_USER_SOURCE_TOKEN_THRESHOLD);
ENVIRONMENT.VITE_PROMPT_OVERHEAD_TOKEN_ESTIMATE = Number(ENVIRONMENT.VITE_PROMPT_OVERHEAD_TOKEN_ESTIMATE);
ENVIRONMENT.VITE_FIRESTORE_EMULATOR_PORT = Number(ENVIRONMENT.VITE_FIRESTORE_EMULATOR_PORT);
ENVIRONMENT.VITE_FUNCTIONS_EMULATOR_PORT = Number(ENVIRONMENT.VITE_FUNCTIONS_EMULATOR_PORT);

export { ENVIRONMENT };
